import { useCallback, useState } from 'react';
import { useRouter } from 'next/navigation';
import sendEventToUmami from '@/client/helpers/trackEvent/sendEventToUmami';
import updateQueryParam from '@/client/utils/updateQueryParam/updateQueryParam';
import debounce from '@/shared/utils/debounce/debounce';

type Props = {
  type: FilterSection;
  searchParams: Partial<Record<string, string>>;
};

const useSelectFilter = ({ type, searchParams }: Props) => {
  const router = useRouter();
  const defaultValue = searchParams[type]?.split(',') ?? [];
  const [selected, setSelected] = useState<string[]>(defaultValue);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const updateURL = useCallback(
    debounce((newSelected: string[]) => {
      const href = window.location.href;
      const backToPageOne = updateQueryParam(href, 'page');
      return router.push(
        updateQueryParam(backToPageOne, type, newSelected.join(',')),
      );
    }, 1000),
    [router, type],
  );

  const handleChange = (newSelected: string[]) => {
    setSelected(newSelected);
    if (type === 'providers') {
      sendEventToUmami({ handle: newSelected }, 'changeProviderFilter');
    }
    if (type === 'categories') {
      sendEventToUmami({ handle: newSelected }, 'changeCategoryFilter');
    }
    updateURL(newSelected);
  };

  return {
    selected,
    handleChange,
  };
};

export default useSelectFilter;
